import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import {ActivatedRoute} from '@angular/router';
import {LocalStorageService, SessionStorageService} from 'angular-web-storage';
import { THEME_TYPE } from '../app.constants';
import {environment} from '../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-themes',
  templateUrl: './themes.component.html',
  styleUrls: ['./themes.component.scss']
})
export class ThemesComponent implements OnInit {

  themeList: any;
  accessPrivileges: string;

  constructor(
    private _appService: AppService,
    private _route: ActivatedRoute,
    private sessionStorage: SessionStorageService,
    private localStorage: LocalStorageService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.spinner.show();

    if (this.sessionStorage.get('accessPrivileges')) {
      this.accessPrivileges = this.sessionStorage.get('accessPrivileges');
    } else {
      this.accessPrivileges = environment.appPrivilege;
    }

    this._appService.getAppsByType(THEME_TYPE).subscribe(res => {
      this.themeList = res;
      this.spinner.hide();
    });
  }

}
